'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var useButtonType = require('./useButtonType.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var _excluded = ["isDisabled", "isLoading", "isActive", "type", "className", "value", "label", "aria-label", "as"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 *
 * `StatisticsButton` displays values of a statistics and are used as controls to switch between multiple views of a graph.
 *
 */
var StatisticsButton = react.forwardRef(function (props, ref) {
  var group = react.useButtonGroup();
  var styles = react.useMultiStyleConfig('StatisticsButton', _objectSpread(_objectSpread({}, group), props));
  var _omitThemingProps = react.omitThemingProps(props),
    _omitThemingProps$isD = _omitThemingProps.isDisabled,
    isDisabled = _omitThemingProps$isD === void 0 ? group === null || group === void 0 ? void 0 : group.isDisabled : _omitThemingProps$isD,
    isLoading = _omitThemingProps.isLoading,
    isActive = _omitThemingProps.isActive,
    type = _omitThemingProps.type,
    className = _omitThemingProps.className,
    value = _omitThemingProps.value,
    label = _omitThemingProps.label;
  _omitThemingProps['aria-label'];
  var as = _omitThemingProps.as,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);

  /**
   * When button is used within ButtonGroup (i.e flushed with sibling buttons),
   * it is important to add a `zIndex` on focus.
   *
   * So let's read the component styles and then add `zIndex` to it.
   */
  var buttonStyles = React__namespace.useMemo(function () {
    var _focus2;
    // @FIXME: Remove `styles as any`. For some reason, it works in Chakra's
    //   own source code, but not in ours. `styles` is a `SystemStyleObject`,
    //   which should have `_focus`.
    var _focus = utils.mergeWith({}, (_focus2 = styles._focus) !== null && _focus2 !== void 0 ? _focus2 : {}, {
      zIndex: 1
    });
    return _objectSpread(_objectSpread({
      display: 'inline-flex',
      flexDirection: 'column',
      appearance: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      userSelect: 'none',
      position: 'relative',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle',
      outline: 'none'
    }, styles.container), !!group && {
      _focus: _focus
    });
  }, [styles, group]);
  var _useButtonType = useButtonType.useButtonType(as),
    _ref = _useButtonType.ref,
    defaultType = _useButtonType.type;
  return /*#__PURE__*/React__namespace.createElement(react.chakra.button, _extends__default["default"]({
    disabled: isDisabled || isLoading,
    ref: react.useMergeRefs(ref, _ref),
    as: as,
    type: type !== null && type !== void 0 ? type : defaultType,
    "data-active": utils.dataAttr(isActive),
    "data-loading": utils.dataAttr(isLoading),
    __css: buttonStyles,
    className: utils.cx('chakra-statistics-button', className)
  }, rest), /*#__PURE__*/React__namespace.createElement(react.chakra.span, {
    __css: styles.value
  }, value), /*#__PURE__*/React__namespace.createElement(react.chakra.span, {
    __css: styles.label
  }, label));
});
StatisticsButton.displayName = 'StatisticsButton';
exports.StatisticsButton = StatisticsButton;